// extracted by mini-css-extract-plugin
export default {"amountLabelWrapper":"AmountLabel-module__amountLabelWrapper--bnVnu","amount":"AmountLabel-module__amount--HPl9w"};